import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncWarehouseSelect } from '../../Shared/AsyncWarehouseSelect'
import AsyncCustomerSelect from '../../Shared/AsyncCustomerSelect'
import AsyncCargoSelect from '../../Shared/AsyncCargoSelect'
import AsyncDriverSelect from '../../Shared/AsyncDriverSelect'
import PriceInput from '../../Shared/PriceInput'
import unitTypes from '../../../_constants/unitTypes'

export default ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  categoryType,
  unitProductOperationType
}) => (
  <div className="row">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="row">
        <div className="form-inline">
          <div className="col-md-3">
            <label>نام انبار</label>
            <AsyncWarehouseSelect
              // categoryType={categoryType}
              defaultValue={values.unitId}
              onChange={(val, unitType_) => {
                if (unitType_ !== undefined) {
                  var unitType = unitTypes.filter(
                    el => el.value === unitType_
                  )[0]

                  if (unitType !== undefined) {
                    categoryType = unitType.categoryType

                    setFieldValue('categoryType', categoryType)
                  }
                }
                setFieldValue('items', [])
                setFieldValue('dto', undefined)
                setFieldValue('unitId', val)
              }}
              className={
                getIn(touched, 'unitId')
                  ? getIn(errors, 'unitId')
                    ? 'semantic-select-box'
                    : 'semantic-select-box'
                  : 'semantic-select-box'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="unitId" />
          </div>

          <div className="col-md-3">
            <label>مشتری</label>
            <AsyncCustomerSelect
              defaultValue={values.customerId}
              onChange={val => {
                console.log(val)
                // setFieldValue('dto', undefined)
                setFieldValue('customerId', val.value)
              }}
              className={
                getIn(touched, 'customerId')
                  ? getIn(errors, 'customerId')
                    ? 'semantic-select-box has-error'
                    : 'semantic-select-box'
                  : 'semantic-select-box has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="customerId" />
          </div>

          {/* <div className="col-md-4">
            <label>باربری</label>
            <AsyncCargoSelect
              defaultValue={values.cargoId}
              onChange={val => {
                console.log(val)
                // setFieldValue('dto', undefined)
                setFieldValue('cargoId', val.value)
              }}
              className={
                getIn(touched, 'cargoId')
                  ? getIn(errors, 'cargoId')
                    ? 'semantic-select-box has-error'
                    : 'semantic-select-box'
                  : 'semantic-select-box has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="cargoId" />
          </div> */}

          <div className="col-md-3">
            <label>راننده</label>
            <AsyncDriverSelect
              defaultValue={values.driverId}
              onChange={val => {
                console.log(val)
                // setFieldValue('dto', undefined)
                setFieldValue('driverId', val.value)
              }}
              className={
                getIn(touched, 'driverId')
                  ? getIn(errors, 'driverId')
                    ? 'semantic-select-box has-error'
                    : 'semantic-select-box'
                  : 'semantic-select-box has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="driverId" />
          </div>

          {/* <div className="clearfix" /> */}

          <div className="col-md-3 col-sm-12">
            <label>شماره حواله راهکاران</label>
            <Field
              type="text"
              name="documentNumber"
              className={
                getIn(errors, 'documentNumber') &&
                getIn(touched, 'documentNumber')
                  ? 'text-input has-error '
                  : 'text-input required '
              }
            />
            <ErrorMessage component={ErrorPopUp} name="documentNumber" />
          </div>

          {/* <div className="col-md-4">
            <label>مبلغ کرایه</label>
            <PriceInput
              value={values.amount}
              onChange={val => {
                console.log(val)

                setFieldValue('amount', val)
              }}
              className={
                getIn(errors, 'amount') && getIn(touched, 'amount')
                  ? 'text-input has-error '
                  : 'text-input required '
              }
            />
            <ErrorMessage component={ErrorPopUp} name="amount" />
          </div> */}

          <div className="clearfix" />

          <div className="col-md-12 col-sm-12">
            <label>توضیحات</label>
            <Field
              name="description"
              rows="1"
              render={({ field }) => (
                <textarea
                  {...field}
                  value={values.description || ''}
                  className="textarea short rtl"
                />
              )}
            />
          </div>

          {/* <div className="col-md-12 col-sm-12">
            <hr />
            <fieldset className="fieldset">
              <WarehouseReceiptProductOperationsTable
                unitId={values.unitId}
                dto={values.dto}
                // brandId={values.brandId}
                // customerId={values.customerId}
                // unitId={values.unitId}
                unitProductOperationType={unitProductOperationType}
                // defaultValue={values.productId}
                onChange={(e) => {
                  // setFieldValue('list', e)
                  console.log(e);
                  
                }}

                className={getIn(touched, "list") ? getIn(errors, "list") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
              />
            </fieldset>
            <ErrorMessage component={ErrorPopUp} name="list" />
          </div> */}
        </div>
      </div>
    </div>
  </div>
)
